import React from 'react';
import queryString from 'query-string';
import { Redirect } from 'react-router-dom';
import { graphql } from 'react-apollo';

import { gqlOauthCallbackTwitter } from 'shared/gql/auth';
import {
  compose,
  getFirstQueryNameOf,
  isEmptyArray,
  oauthStore,
  omitDeep,
} from 'shared/helpers';
import { GenericPSA, GenericError } from 'pages';


const TwitterCallback = ({ data }) => {
  if (data.error) {
    return <GenericError />;
  }

  if (data.loading) {
    return (
      <GenericPSA
        headline="Verifying.."
        subheading="This may take a second, please keep this window open."
      />
    );
  }

  const key = getFirstQueryNameOf(gqlOauthCallbackTwitter);
  const { [key]: payload } = data;
  const { errors, oauthUser } = payload;

  if (!isEmptyArray(errors)) {
    return <GenericError />;
  }

  if (!oauthUser || !oauthUser.platform) {
    return <GenericError />;
  }

  // Save in local storage,
  // but filter out keys that aren't part of the type definition
  // first b/c if we send it back later w/ additional fields,
  // absinthe will not treat it as the type.
  oauthStore.set(
    oauthUser.platform,
    omitDeep(oauthUser, ['__typename'])
  );

  return (
    <Redirect
      to={{
        pathname: '/',
        state: {
          restore: true,
          isStagingContent: true,
        }
      }}
    />
  );
};


const parseQueryParams = (location) => {
  const parsed = queryString.parse(location.search);
  const { oauth_token, oauth_verifier } = parsed;
  return { oauth_token, oauth_verifier };
};


export default compose(
  graphql(gqlOauthCallbackTwitter, {
    options: props => ({
      variables: parseQueryParams(props.location),
    }),
  }),
)(TwitterCallback);



// WEBPACK FOOTER //
// ./src/pages/a/oauth/TwitterCallback.js